export default __webpack_public_path__ + "static/media/4.ac91b6fc.jpg";